var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"foot-container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"foot-bottom layout-column layout-center"},[_c('div',[_vm._v(_vm._s(_vm.footList.copyrightStatement))]),_c('div',{staticClass:"bottom-txt"},[_vm._v("邮箱地址："+_vm._s(_vm.footList.email))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }